import { Skeleton } from '@/shared/components/Skeleton';
import { cn } from '@/shared/utils/cn';

export interface ProductCardSkeletonProps {
  className?: string;
}

/**
 * Skeleton for a single product card – matches ProductCard layout:
 * image block, title lines, price, discount, action buttons.
 * Reusable anywhere a product card loading state is needed.
 */
export function ProductCardSkeleton({ className }: ProductCardSkeletonProps) {
  return (
    <article
      className={cn(
        'flex flex-col overflow-hidden rounded-md border border-gray-200 bg-white',
        className
      )}
      aria-hidden
    >
      <div className="relative aspect-square bg-gray-100">
        <Skeleton className="h-full w-full rounded-none" />
      </div>
      <div className="flex flex-1 flex-col px-3 pb-3 pt-2">
        <Skeleton className="mb-2 h-3 w-full rounded" />
        <Skeleton className="mb-1 h-3 w-[80%] rounded" />
        <div className="mb-2 flex items-baseline gap-1">
          <Skeleton className="h-3.5 w-16 rounded" />
          <Skeleton className="h-3 w-12 rounded" />
        </div>
        <Skeleton className="mb-3 h-3 w-3/4 rounded" />
        <div className="mt-auto flex gap-2">
          <Skeleton className="h-8 w-8 shrink-0 rounded" />
          <Skeleton className="h-8 flex-1 rounded" />
        </div>
      </div>
    </article>
  );
}
